import { useRouter } from 'next/router';
import { useBasePath } from '../../../lib/use-base-path';
import { chatHandoffLink } from '../../../lib/chat-handoff';

// Hands a message off to a fresh floating-chat thread (the `?new=…&prefill=…&autosend=1`
// route). Shared by the composer's submit and the "for you" suggestion grid.
export function useHomeHandoff() {
  const router = useRouter();
  const basePath = useBasePath();
  return (message: string) => {
    const trimmed = message.trim();
    if (!trimmed) return;
    const link = chatHandoffLink({ kind: 'new', message: trimmed }, basePath);
    void router.push(link.route, link.path);
  };
}
